<script setup lang="ts">
import { WrapperGeneralInfo } from '@shared/ui/wrappers'
import { CardAdmin } from '@shared/ui/cards'
import { BtnPrimary } from '@shared/ui/buttons'

import { useTutorKanbanStore } from '../model/store'
import { useTutorKanbanSave } from '../model/tutor-kanban-save.hook'
import TutorKanbanGeneralInfo from './TutorKanbanGeneralInfo.vue'
import TutorKanbanMainInfo from './TutorKanbanMainInfo.vue'
import TutorKanbanPolicy from './TutorKanbanPolicy.vue'
import TutorKanbanLinks from './TutorKanbanLinks.vue'

defineOptions({
  name: 'TutorKanbanGeneral',
})

const tutorKanbanStore = useTutorKanbanStore()
const { setSubmitUpdate } = useTutorKanbanSave()
</script>

<template>
  <CardAdmin
    :title="tutorKanbanStore.getTutor?.full_name"
    :subtitle="`#${tutorKanbanStore.getTutor?.id}`"
    fullwidth
  >
    <template #header>
      <BtnPrimary
        text="Save"
        color="emerald"
        @click="setSubmitUpdate"
      />
    </template>
    <WrapperGeneralInfo>
      <template #info>
        <TutorKanbanGeneralInfo />
      </template>
      <template #additional>
        <TutorKanbanMainInfo />
        <TutorKanbanPolicy />
        <TutorKanbanLinks />
      </template>
    </WrapperGeneralInfo>
  </CardAdmin>
</template>
